module.exports = __webpack_public_path__ + "img/146ne.45281b42.svg";